/* eslint-disable no-underscore-dangle */
/**
 * 给组件加入自动blur验证功能
 * 使用方法
 * <valid-van-field
 *      v-model="loanAmount"
 *      label="借款金额"
 *       :placeholder="moneyPlaceholder"
 *       :rules="[{required: true, message: '不能为空'},{ pattern: /^[0-9]{3,10}$/, message: '三到10位数字' }]"
 *    />
 *   验证规则目前只支持required和pattern
 */
export default function (WComponent) {
  return {
    name: 'valid-van-field',
    WrapErrorMessage: '',
    methods: {
      ...WComponent.methods,
    },
    computed: {
      inputListeners() {
        const vm = this;
        // `Object.assign` 将所有的对象合并为一个新对象
        return {

          // 我们从父级添加所有的监听器
          ...WComponent.$listeners,
          // 然后我们添加自定义监听器，
          // 或覆写一些监听器的行为
          // 这里确保组件配合 `v-model` 的工作
          input(event) {
            const data = event;
            let hasError = false;
            // eslint-disable-next-line no-unused-expressions
            vm.rules
                  && vm.rules.forEach((rule) => {
                    if (hasError) {
                      return;
                    }
                    if (rule.required === true && !data) {
                      vm.WrapErrorMessage = rule.message;
                      hasError = true;
                      return;
                    }
                    if (rule.pattern && !rule.pattern.test(data)) {
                      console.log(rule.pattern.test(data), rule.message);
                      vm.WrapErrorMessage = rule.message;
                      hasError = true;
                      return;
                    }
                    if (rule.vfunc && !rule.vfunc(data, vm.min, vm.max)) {
                      vm.WrapErrorMessage = rule.message;
                      hasError = true;
                    }
                  });
            console.log(hasError);
            if (!hasError) {
              vm.WrapErrorMessage = '';
            }
            console.log(vm.WrapErrorMessage);
            vm.$emit('input', data);
          },
        };
      },
    },
    props: {
      ...WComponent.props,
      rules: Array,
      min: Number,
      max: Number,
      // WrapErrorMessage: String,
    },
    render(createElement) {
      // 逻辑处理
      const slots = Object.keys(this.$slots)
        .reduce((arr, key) => arr.concat(this.$slots[key]), [])
      // 手动更正 context
        .map((vnode) => {
          // eslint-disable-next-line no-param-reassign
          vnode.context = this._self;
          return vnode;
        });

      return createElement(
        WComponent,
        {
          on: this.inputListeners,
          attrs: this.$attrs,
          props: {
            ...this.$props,
            errorMessage: this.WrapErrorMessage,
          },
        },
        slots,
      );
    },
  };
}
